import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 8px;
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 11px;
  border: 1px solid ${({ selected }) => (selected ? '#1890ff' : '#444')};
  background-color: ${({ selected }) => (selected ? '#141414' : '#1f1f1f')};
  border-radius: 8px;
  transition: all 0.3s;
  cursor: pointer;
  color: #fff;

  &:hover {
    border-color: #1890ff;
  }
`;

export const RadioWrapper = styled.div`
  margin-top: 6px;
`;

export const Content = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const Description = styled.div`
  font-size: 12px;
  color: #bbb;
`;
